module.exports = {
  white: '#ffffff',
  transparent: 'transparent',

  black: {
    10: 'rgba(0,0,0,0.10)',
    20: 'rgba(0,0,0,0.20)',
    30: 'rgba(0,0,0,0.30)',
    40: 'rgba(0,0,0,0.40)',
    50: 'rgba(0,0,0,0.50)',
    60: 'rgba(0,0,0,0.60)',
    70: 'rgba(0,0,0,0.70)',
    80: 'rgba(0,0,0,0.80)',
    90: 'rgba(0,0,0,0.90)',
    default: '#000000'
  },

  blue: {
    10: '#edf4ff',
    20: '#c9deff',
    30: '#97c1ff',
    40: '#6ea6ff',
    50: '#408bfc',
    60: '#0062ff',
    70: '#054ada',
    80: '#0530ad',
    90: '#061f80',
    100: '#051243'
  },
  coolGray: {
    10: '#f2f4f8',
    20: '#d5d9e0',
    30: '#b9bfc7',
    40: '#9fa5ad',
    50: '#868d95',
    60: '#697077',
    70: '#50565b',
    80: '#373d42',
    90: '#242a2e',
    100: '#13171a'
  },
  cyan: {
    10: '#e3f6ff',
    20: '#b3e6ff',
    30: '#6ccaff',
    40: '#30b0ff',
    50: '#1191e6',
    60: '#0072c3',
    70: '#0058a1',
    80: '#003d73',
    90: '#002b50',
    100: '#07192b'
  },
  gray: {
    10: '#f3f3f3',
    20: '#dcdcdc',
    30: '#bebebe',
    40: '#a4a4a4',
    50: '#8c8c8c',
    60: '#6f6f6f',
    70: '#565656',
    80: '#3d3d3d',
    90: '#282828',
    100: '#171717'
  },
  green: {
    10: '#dafbe4',
    20: '#9deeb2',
    30: '#56d679',
    40: '#3dbb61',
    50: '#24a148',
    60: '#198038',
    70: '#10642a',
    80: '#054719',
    90: '#01330f',
    100: '#081b09'
  },
  magenta: {
    10: '#fff0f6',
    20: '#ffcfe1',
    30: '#ffa0c2',
    40: '#fa75a6',
    50: '#ee538b',
    60: '#d12765',
    70: '#a11950',
    80: '#760a3a',
    90: '#57002b',
    100: '#2a0a16'
  },
  orange: {
    40: '#fc7b1e'
  },
  purple: {
    10: '#f7f1ff',
    20: '#e6d6ff',
    30: '#d0b0ff',
    40: '#bb8eff',
    50: '#a66efa',
    60: '#8a3ffc',
    70: '#6e32c9',
    80: '#4f2196',
    90: '#38146b',
    100: '#1e1033'
  },
  red: {
    10: '#fff0f1',
    20: '#fcd0d3',
    30: '#ffa4a9',
    40: '#ff767c',
    50: '#fb4b53',
    60: '#da1e28',
    70: '#a51920',
    80: '#750e13',
    90: '#570408',
    100: '#2c080a'
  },
  teal: {
    10: '#dbfbfb',
    20: '#92eeee',
    30: '#20d5d2',
    40: '#00bab6',
    50: '#009c98',
    60: '#007d79',
    70: '#006161',
    80: '#004548',
    90: '#003137',
    100: '#081a1c'
  },
  warmGray: {
    10: '#f7f3f1',
    20: '#e0dbda',
    30: '#c1bcbb',
    40: '#a7a2a2',
    50: '#8f8b8b',
    60: '#726e6e',
    70: '#595555',
    80: '#403c3c',
    90: '#2b2828',
    100: '#1a1717'
  },
  yellow: {
    20: '#fdd13a'
  }
}
